export interface PpAnalysisWaacDTO {
  companyId: number;
  companyName: string;
  status: PortfolioStatus;
  dateOfInitialInvestment: string;
  wgl: PaTotalsDTO;
  atCost: PaTotalsDTO;
  total: PaTotalsDTO;
  ratios: PaRatiosDTO;
}

export interface PaTotalsDTO {
  cost: number;
  fmv: number;
  multiple: number;
}

export interface PaRatiosDTO {
  wglCostRatio: number;
  atCostCostRatio: number;
  wglFmvRatio: number;
  atCostFmvRatio: number;
}

export interface PaGrandTotal {
  withGainLossTotals: PaTotalsDTO;
  atCostTotals: PaTotalsDTO;
  combinedTotals: PaTotalsDTO;
  combinedRatios: PaRatiosDTO;
}

export enum PortfolioStatus {
  REALIZED = 'Realized',
  ACTIVE = 'Active',
  PARTIALLY_REALIZED = 'Partially realized',
}
